import React,{Component} from 'react';
import {variables} from '../../Variables.js';
import MyPage from "../../../src/MyPage";
import SubTabsInputs from "../../../src/SubTabsInputs.js";
import { isSuperAdmin } from "./../../helpers/user.js";
import { Blocks } from 'react-loader-spinner'
import axiosService from '../../helpers/axios';

  export default class InputsBudgetPaidYear extends Component{ 

    constructor(props){
      super(props);

      this.state={
          bpyears:[],
          modalTitle:"",
          bpyid:0,
          yearid: 0,
          july:"",
          august:"",
          september:"",
          october: "",
          november: "",
          december: "",
          january: "",
          february: "",
          march: "",
          april: "",
          may: "",
          june:"",

		year: {
			yearid:0,
			fyname:"",
			isactive: true
		},
          FiscalYearFilter:"",
          BpyIdFilter:"",

          fiscalYears: [], 
          loading: true,
          isEditClicked: false,
          fiscalYear:"",
          fiscalMonth:"",
          uniqueRowConcat:[]
          
      }
  }


  getCurrentFinancialYearAndMonth() {
    const today = new Date();
    let fiscalYear = "";
    let fiscalMonth = "";
  
    // Determine fiscal year
    if ((today.getMonth() + 1) <= 6) {
      fiscalYear = (today.getFullYear());
    } else {
      fiscalYear = today.getFullYear() + 1;
    }
  
    // Determine fiscal month
    fiscalMonth = (today.getMonth() + 1); // Adding 1 as months are 0-indexed
  
    return {
      fiscalYear: fiscalYear,
      fiscalMonth: fiscalMonth
    };
  }

  FilterFn(){

    var FiscalYearFilter = this.state.FiscalYearFilter;
    var BpyIdFilter = this.state.BpyIdFilter;


    var filteredData=this.state.bpyearsWithoutFilter.filter(
        function(el){
            return el.bpyid.toString().toLowerCase().includes(
              BpyIdFilter.toString().trim().toLowerCase())
              &&
                el.year?.fyname.toString().toLowerCase().includes(
                FiscalYearFilter.toString().trim().toLowerCase()
            )
        }
    );

    this.setState({bpyears:filteredData});

}



sortResult(prop,asc){
  var sortedData=this.state.bpyearsWithoutFilter.sort(function(a,b){
      if(asc){
          return (a[prop]>b[prop])?1:((a[prop]<b[prop])?-1:0);
      }
      else{
          return (b[prop]>a[prop])?1:((b[prop]<a[prop])?-1:0);
      }
  });

  this.setState({bpyears:sortedData});

}



changeFiscalYearFilter = (e)=>{
    this.state.FiscalYearFilter=e.target.value;
    this.FilterFn();
  }

  changeBpyIdFilter = (e)=>{
    this.state.BpyIdFilter=e.target.value;
    this.FilterFn();
  }


refreshList = () => {
    axiosService.get('/budgetpaidyear/')
      .then((response) => {
        const data = response.data?.results ?? response.data;
        this.setState({ bpyears: data, bpyearsWithoutFilter: data, loading: false });
      })
      .catch((error) => {
        console.error('Error fetching data:', error);
        this.setState({ loading: false });
      });
  };

  fetchUniqueRowConcat() {
    axiosService.get('/budgetpaidyear/')
      .then(response => {
        const data = response.data?.results ?? response.data;
        const result = Array.from(new Set(data.map(item => `${item.year.fyname}`)));
        this.setState({ uniqueRowConcat: result });
      })
      .catch(error => {
        console.error("Error fetching concatList:", error);
      });
  }


fetchFiscalYears() {
    axiosService.get('/years/')
      .then(response => {
        const data = response.data?.results ?? response.data;
        const filteredData = data.filter(item => item.isactive === true);
        const fiscalYears = filteredData.map(item => item.fyname);
        this.setState({ fiscalYears: fiscalYears });
      })
      .catch(error => {
        console.error("Error fetching fiscal years:", error);
      });
  }


handleInput = (event) => {
    const inputValue = event.target.value;
    const regex = /^\d*$/;
    if (!regex.test(inputValue)) {
      event.target.value = inputValue.replace(/[^0-9]/g, '');
    }
  };


  formatUpdateDate(update_y) {
    if (!update_y) {
      return 'N/A'; // Handle the case where update_y is not available
    }

    const parsedDate = new Date(update_y);
    const formattedDate = parsedDate.toLocaleDateString(); // Adjust the format as needed

    return formattedDate;
  }


componentDidMount(){
  this.refreshList();
  this.fetchFiscalYears();
  this.fetchUniqueRowConcat();

}


changeFiscalYear =(e)=>{
    this.setState({fyname:e.target.value});
  }


changeJuly =(e)=>{
    this.setState({july:e.target.value});
  }

changeAugust =(e)=>{
    this.setState({august:e.target.value});
  }

changeSeptember =(e)=>{
    this.setState({september:e.target.value});
  }

changeOctober =(e)=>{
    this.setState({october:e.target.value});
  }
changeNovember =(e)=>{
    this.setState({november:e.target.value});
  }

changeDecember =(e)=>{
    this.setState({december:e.target.value});
  }

changeJanuary=(e)=>{
    this.setState({january:e.target.value});
  }

changeFebruary =(e)=>{
    this.setState({february:e.target.value});
  }

changeMarch =(e)=>{
    this.setState({march:e.target.value});
  }

changeApril =(e)=>{
    this.setState({april:e.target.value});
  }

changeMay =(e)=>{
    this.setState({may:e.target.value});
  }

changeJune =(e)=>{
    this.setState({june:e.target.value});
  }

addClick(){
  this.setState({
      modalTitle:"Add Budget",
      bpyid:0,
      fyname:"",
      july:"",
      august:"",
      september:"",
      october:"",
      november:"",
      december:"",
      january:"",
      february:"",
      march:"",
      april:"",
      may:"",
      june:"",
      isEditClicked: false,
  });
}


editClick(dep) {
  this.setState({
    modalTitle: "Edit Budget",
    bpyid: dep.bpyid,
    fyname:dep.year.fyname,
    july:dep.july,
    august:dep.august,
    september:dep.september,
    october:dep.october,
    november:dep.november,
    december:dep.december,
    january:dep.january,
    february:dep.february,
    march:dep.march,
    april:dep.april,
    may:dep.may,
    june:dep.june,
    initialFyname:dep.year.fyname,
    initialJuly:dep.july,
    initialAugust:dep.august,
    initialSeptember:dep.september,
    initialOctober:dep.october,
    initialNovember:dep.november,
    initialDecember:dep.december,
    initialJanuary:dep.january,
    initialFebruary:dep.february,
    initialMarch:dep.march,
    initialApril:dep.april,
    initialMay:dep.may,
    initialJune:dep.june,
    isEditClicked: true,
  });
}

createClick() {
  const {   fyname, july, august, september, october,
  november, december, january, february, march, april, may, june, uniqueRowConcat  } = this.state;

 

  if (!fyname) {
    alert('Year is required');
    return;
  }

  if (uniqueRowConcat.includes(`${fyname}`)) {
    alert('This record already exists. Modify your information or modify the existing record');
    return;
}


  axiosService.post('/budgetpaidyear_create/', {
    fyname: fyname,
    july:july,
    august:august,
    september:september,
    october:october,
    november:november,
    december:december,
    january:january,
    february:february,
    march:march,
    april:april,
    may:may,
    june:june
  })
    .then(result => {
      alert('Budget created');
      this.refreshList();
      //window.location.reload();
    })
    .catch(error => {
      alert('Failed');
    });
}

updateClick(id) {
  const {   fyname,  july, august, september, october,
    november, december, january, february, march, april, may, june, 
     initialFyname,  initialJuly, initialAugust,
    initialSeptember, initialOctober, initialNovember, initialDecember, initialJanuary,
    initialFebruary, initialMarch, initialApril, initialMay, initialJune } = this.state;

  if (

    fyname === initialFyname &&
    july === initialJuly &&
    august === initialAugust &&
    september === initialSeptember &&
    october === initialOctober &&
    november === initialNovember &&
    december === initialDecember &&
    january === initialJanuary &&
    february === initialFebruary &&
    march === initialMarch &&
    april === initialApril &&
    may === initialMay &&
    june === initialJune
  ) {
    alert('No changes detected');
    return;
  }



  if (!fyname) {
    alert('Year is required');
    return;
  }

  

  
  axiosService.patch('/budgetpaidyear/' + id + '/', {
    fyname: this.state.fyname,
    july : this.state.july,
    august : this.state.august,
    september : this.state.september,
    october : this.state.october,
    november : this.state.november,
    december : this.state.december,
    january : this.state.january,
    february : this.state.february,
    march : this.state.march,
    april : this.state.april,
    may : this.state.may,
    june : this.state.june
  })
    .then(result => {
      alert('Update successful');
      this.refreshList();
      //window.location.reload(); // Refresh the page
    })
    .catch(error => {
      alert('Failed');
    });
}



copyClick() {
  const {  fyname,  july, august, september, october,
    november, december, january, february, march, april, may, june, 
     initialFyname, initialJuly, initialAugust,
    initialSeptember, initialOctober, initialNovember, initialDecember, initialJanuary,
    initialFebruary, initialMarch, initialApril, initialMay, initialJune  } = this.state;

  if (

    fyname === initialFyname &&

    july === initialJuly &&
    august === initialAugust &&
    september === initialSeptember &&
    october === initialOctober &&
    november === initialNovember &&
    december === initialDecember &&
    january === initialJanuary &&
    february === initialFebruary &&
    march === initialMarch &&
    april === initialApril &&
    may === initialMay &&
    june === initialJune 
  ) {
    alert('No changes detected');
    return;
  }





  if (!fyname) {
    alert('Year is required');
    return;
  }

  
  axiosService.post('/budgetpaidyear_create/', {
    fyname: this.state.fyname,
    july : this.state.july,
    august : this.state.august,
    september : this.state.september,
    october : this.state.october,
    november : this.state.november,
    december : this.state.december,
    january : this.state.january,
    february : this.state.february,
    march : this.state.march,
    april : this.state.april,
    may : this.state.may,
    june : this.state.june,

  })
    .then(result => {
      alert('Budget created');
      this.refreshList();
      //window.location.reload(); // Refresh the page
    })
    .catch(error => {
      alert('Failed');
    });
}

deleteClick(id) {
  if (window.confirm('Are you sure?')) {
    axiosService.delete('/budgetpaidyear/' + id + '/')
      .then(res => {
        alert('Delete successful');
        this.refreshList();
        window.location.reload();
      })
      .catch(error => {
        alert(error?.response?.data?.error || error?.message || 'Delete failed');
      });
  }
}


render(){
  const {
      bpyears,
      modalTitle,
      bpyid,
      july,
      august,
      september,
      october,
      november,
      december,
      january,
      february,
      march,
      april,
      may,
      june,
      loading
     

  }=this.state;

  const { fiscalYear, fiscalMonth } = this.getCurrentFinancialYearAndMonth();
  const selectedFiscalYear = parseInt(this.state.fyname, 10);
  const selectedMonthIsJuly = parseInt(7, 10);
  const selectedMonthIsAugust = parseInt(8, 10);
  const selectedMonthIsSeptember = parseInt(9, 10);
  const selectedMonthIsOctober = parseInt(10, 10);
  const selectedMonthIsNovember = parseInt(11, 10);
  const selectedMonthIsDecember = parseInt(12, 10);

  const selectedMonthIsJanuary = parseInt(1, 10);
  const selectedMonthIsFebruary = parseInt(2, 10);
  const selectedMonthIsMarch = parseInt(3, 10);
  const selectedMonthIsApril = parseInt(4, 10);
  const selectedMonthIsMay = parseInt(5, 10);
  const selectedMonthIsJune = parseInt(6, 10);

  const isDisabledYear = fiscalYear > selectedFiscalYear;
  const isBetweenJulyAndDecember =
  fiscalMonth >= 7 && fiscalMonth <= 12; // Check if fiscal month is between July (6) and November (11) inclusive
  const isBetweenJanuaryAndJune =
  fiscalMonth >= 1 && fiscalMonth <= 6;

  const isYearCanBeDisable = selectedFiscalYear <= fiscalYear ; // Check if it's the selected fiscal year
  const isPassedMonthJuly = fiscalMonth > selectedMonthIsJuly;
  const isDisabledMonthJuly = (isYearCanBeDisable && isBetweenJulyAndDecember && isPassedMonthJuly) || isDisabledYear;
  const isPassedMonthAugust = fiscalMonth > selectedMonthIsAugust;
  const isDisabledMonthAugust = (isYearCanBeDisable && isBetweenJulyAndDecember && isPassedMonthAugust) || isDisabledYear;
  const isPassedMonthSeptember = fiscalMonth > selectedMonthIsSeptember;
  const isDisabledMonthSeptember = (isYearCanBeDisable && isBetweenJulyAndDecember && isPassedMonthSeptember) || isDisabledYear;
  const isPassedMonthOctober = fiscalMonth > selectedMonthIsOctober;
  const isDisabledMonthOctober = (isYearCanBeDisable && isBetweenJulyAndDecember && isPassedMonthOctober) || isDisabledYear;
  const isPassedMonthNovember = fiscalMonth > selectedMonthIsNovember;
  const isDisabledMonthNovember = (isYearCanBeDisable && isBetweenJulyAndDecember && isPassedMonthNovember) || isDisabledYear;
  const isPassedMonthDecember =  selectedMonthIsDecember && isBetweenJanuaryAndJune ;
  const isDisabledMonthDecember = (isYearCanBeDisable && isBetweenJulyAndDecember && isPassedMonthDecember) || isDisabledYear;

  const isPassedMonthJanuary = fiscalMonth > selectedMonthIsJanuary;
  const isDisabledMonthJanuary = (isYearCanBeDisable && isBetweenJanuaryAndJune && isPassedMonthJanuary) || isDisabledYear;
  const isPassedMonthFebruary = fiscalMonth > selectedMonthIsFebruary;
  const isDisabledMonthFebruary= (isYearCanBeDisable && isBetweenJanuaryAndJune && isPassedMonthFebruary) || isDisabledYear;
  const isPassedMonthMarch = fiscalMonth > selectedMonthIsMarch;
  const isDisabledMonthMarch = (isYearCanBeDisable && isBetweenJanuaryAndJune && isPassedMonthMarch) || isDisabledYear;
  const isPassedMonthApril = fiscalMonth > selectedMonthIsApril;
  const isDisabledMonthApril = (isYearCanBeDisable && isBetweenJanuaryAndJune && isPassedMonthApril) || isDisabledYear;
  const isPassedMonthMay = fiscalMonth > selectedMonthIsMay;
  const isDisabledMonthMay = (isYearCanBeDisable && isBetweenJulyAndDecember && isPassedMonthMay) || isDisabledYear;
  const isPassedMonthJune =  selectedMonthIsJune && isBetweenJulyAndDecember ;
  const isDisabledMonthJune = (isYearCanBeDisable && isBetweenJanuaryAndJune && isPassedMonthJune) || isDisabledYear;

  return(
    
<div className="scrollable-container" >
<MyPage />
<SubTabsInputs />
<button type="button"
disabled={!isSuperAdmin()}
className="btn btn-primary m-2 float-end"
data-bs-toggle="modal"
data-bs-target="#exampleModal"
onClick={()=>this.addClick()}
style={{  height: "28px", fontSize: "12px" ,textAlign:"center"}}
>
  Add Budget Year
</button>

<div className="table-container">
<table className="table table-striped" >
<thead>
<tr  className="header-row-fixed">

  <th  style={{  fontSize: "12px" ,textAlign:"center"}}>
      <div className="d-flex flex-row align-items-center justify-content-center"
      
      >
      <input className="form-control m-2"
      style={{ width: "70px", height:"30px", fontSize: "12px" }} // Set the width to 200 pixels (you can adjust the value as needed)
      onChange={this.changeBpyIdFilter}
      placeholder="Filter"/>

      </div>
      bpwId
  </th>

  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
  <input className="form-control m-2"
   style={{ width: "70px", height:"30px", fontSize: "12px" }} // Set the width to 200 pixels (you can adjust the value as needed)
      onChange={this.changeFiscalYearFilter}
      placeholder="Filter"/>
      </div>
      Fiscal Year
  </th>


  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Jul
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Aug
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Sep
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Oct
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Nov
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Dec
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Jan
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Feb
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Mar
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Apr
  </th>

  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      May
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
  <div className="d-flex flex-row align-items-center justify-content-center">
      </div>
      Jun
  </th>
  <th style={{  fontSize: "12px" ,textAlign:"center"}}>
      Options
  </th>
</tr>
</thead>
{loading ? (
          <div style={{ display: 'flex',flexDirection: 'column', justifyContent: 'center', alignItems: 'center', height: '40vh', width:'150vh' }}>
            {/* Use react-loader-spinner here */}
            <Blocks visible={true} height="100" width="100" ariaLabel="blocks-loading" wrapperStyle={{}} wrapperClass="blocks-wrapper"/>
            <div style={{ marginLeft: '10px' }}>Loading...</div>
          </div>
        ) : (
<tbody>
  {bpyears.map(dep=>
      <tr key={dep.bpyid} className="row-hover">
          <td className="table-text">{dep.bpyid}</td>
          <td className="table-text">{dep.year?.fyname ?? 'N/A'}</td>
          <td className="table-text">{dep.july ? Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR', minimumFractionDigits: 0, maximumFractionDigits: 3 }).format(dep.july) : 'N/A'}</td>
          <td className="table-text">{dep.august ? Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR', minimumFractionDigits: 0, maximumFractionDigits: 3 }).format(dep.august) : 'N/A'}</td>
          <td className="table-text">{dep.september ? Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR', minimumFractionDigits: 0, maximumFractionDigits: 3 }).format(dep.september) : 'N/A'}</td>
          <td className="table-text">{dep.october ? Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR', minimumFractionDigits: 0, maximumFractionDigits: 3 }).format(dep.october) : 'N/A'}</td>
          <td className="table-text">{dep.november ? Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR', minimumFractionDigits: 0, maximumFractionDigits: 3 }).format(dep.november) : 'N/A'}</td>
          <td className="table-text">{dep.december ? Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR', minimumFractionDigits: 0, maximumFractionDigits: 3 }).format(dep.december) : 'N/A'}</td>
          <td className="table-text">{dep.january ? Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR', minimumFractionDigits: 0, maximumFractionDigits: 3 }).format(dep.january) : 'N/A'}</td>
          <td className="table-text">{dep.february ? Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR', minimumFractionDigits: 0, maximumFractionDigits: 3 }).format(dep.february) : 'N/A'}</td>
          <td className="table-text">{dep.march ? Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR', minimumFractionDigits: 0, maximumFractionDigits: 3 }).format(dep.march) : 'N/A'}</td>
          <td className="table-text">{dep.april ? Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR', minimumFractionDigits: 0, maximumFractionDigits: 3 }).format(dep.april) : 'N/A'}</td>
          <td className="table-text">{dep.may ? Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR', minimumFractionDigits: 0, maximumFractionDigits: 3 }).format(dep.may) : 'N/A'}</td>
          <td className="table-text">{dep.june ? Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR', minimumFractionDigits: 0, maximumFractionDigits: 3 }).format(dep.june) : 'N/A'}</td>
          <td className="table-text">

          <div style={{ display: "flex", justifyContent: "center" }}>

          <button type="button"
          disabled={!isSuperAdmin()}
          className="btn btn-light mr-1  p-0"
          data-bs-toggle="modal"
          data-bs-target="#exampleModal2"
          onClick={()=>this.editClick(dep)}>
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-pencil-square" viewBox="0 0 16 16">
              <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z"/>
              <path fillRule="evenodd" d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5v11z"/>
              </svg>
          </button>

          <button type="button"
          disabled={!isSuperAdmin()}
          className="btn btn-light mr-1  p-0"
          onClick={()=>this.deleteClick(dep.bpyid)}>
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-trash-fill" viewBox="0 0 16 16">
              <path d="M2.5 1a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1H3v9a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V4h.5a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H10a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1H2.5zm3 4a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 .5-.5zM8 5a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7A.5.5 0 0 1 8 5zm3 .5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 1 0z"/>
              </svg>
          </button>
          </div>
          </td>
      </tr>
      )}
</tbody>
 )
}
</table>
</div>



<div className="modal fade" id="exampleModal" tabIndex="-1" aria-hidden="true">
  <div className="modal-dialog modal-lg modal-dialog-centered">
    <div className="modal-content">
      <div className="modal-header">
        <h5 className="modal-title" style={{ fontSize: "12px" }} >{modalTitle}</h5>
        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div className="modal-body">

      <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }} >Fiscal Year</span>
          <select
            className="form-select"
            value={this.state.fyname}
            onChange={(event) => this.setState({ fyname: event.target.value })}
            disabled={this.state.isEditClicked}
            style={{ fontSize: "12px" }} 
          >
            <option value="">Select fiscal year</option>
            {this.state.fiscalYears.map((fiscalyear) => (
              <option key={fiscalyear} value={fiscalyear}>
                {fiscalyear}
              </option>
            ))}
          </select>
        </div>
        



        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }} >Jul</span>
          <input type="number" className="form-control" value={july} onChange={this.changeJuly} 
          style={{ fontSize: "12px" }} 
          />
        </div>

        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }} >Aug</span>
          <input type="text" className="form-control" value={august} onChange={this.changeAugust}
          style={{ fontSize: "12px" }} 
           />
        </div>

        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>Sep</span>
          <input type="text" className="form-control" value={september} onChange={this.changeSeptember} 
          style={{ fontSize: "12px" }}
          />
        </div>

        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>Oct</span>
          <input type="text" className="form-control" value={october} onChange={this.changeOctober} 
          style={{ fontSize: "12px" }}
          />
        </div>
        
        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>Nov</span>
          <input type="text" className="form-control" value={november} onChange={this.changeNovember} 
          style={{ fontSize: "12px" }}
          />
        </div>

        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>Dec</span>
          <input type="text" className="form-control" value={december} onChange={this.changeDecember} 
          style={{ fontSize: "12px" }}
          />
        </div>

        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>Jan</span>
          <input type="text" className="form-control" value={january} onChange={this.changeJanuary} 
          style={{ fontSize: "12px" }}
          />

        </div>

        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>Feb</span>
          <input type="text" className="form-control" value={february} onChange={this.changeFebruary} 
          style={{ fontSize: "12px" }}
          />
        </div>
        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>Mar</span>
          <input type="text" className="form-control" value={march} onChange={this.changeMarch} 
          style={{ fontSize: "12px" }}
          />
        </div>

        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>Apr</span>
          <input type="text" className="form-control" value={april} onChange={this.changeApril} 
          
          style={{ fontSize: "12px" }}
          />
        </div>
        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>May</span>
          <input type="text" className="form-control" value={may} onChange={this.changeMay} 
          
          style={{ fontSize: "12px" }}
          />

        </div>

        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>Jun</span>
          <input type="text" className="form-control" value={june} onChange={this.changeJune} 
          
          style={{ fontSize: "12px" }}
          />

        </div>

        {bpyid === 0 ? (
          <button type="button" className="btn btn-primary float-start" style={{ fontSize: "12px" }} onClick={() => this.createClick()}>
            Create
          </button>
        ) : null}

        {bpyid !== 0 ? (
          <button type="button" className="btn btn-primary float-start" style={{ fontSize: "12px" }} onClick={() => this.updateClick(bpyid)}>
            Update
          </button>
        ) : null}
      </div>
    </div>
  </div>
</div>

<div className="modal fade" id="exampleModal1" tabIndex="-1" aria-hidden="true">
  <div className="modal-dialog modal-lg modal-dialog-centered">
    <div className="modal-content">
      <div className="modal-header">
        <h5 className="modal-title" style={{ fontSize: "12px" }} >{modalTitle}</h5>
        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div className="modal-body">

      <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }} >Fiscal Year</span>
          <select
            className="form-select"
            value={this.state.fyname}
            onChange={(event) => this.setState({ fyname: event.target.value })}
           
            style={{ fontSize: "12px" }} 
          >
            <option value="">Select fiscal year</option>
            {this.state.fiscalYears.map((fiscalyear) => (
              <option key={fiscalyear} value={fiscalyear}>
                {fiscalyear}
              </option>
            ))}
          </select>
        </div>
        




        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }} >Jul</span>
          <input type="number" className="form-control" value={july} onChange={this.changeJuly} 
          
          style={{ fontSize: "12px" }} 
          />
        </div>

        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }} >Aug</span>
          <input type="text" className="form-control" value={august} onChange={this.changeAugust}
          
          style={{ fontSize: "12px" }} 
           />
        </div>

        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>Sep</span>
          <input type="text" className="form-control" value={september} onChange={this.changeSeptember} 
          
          style={{ fontSize: "12px" }}
          />
        </div>

        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>Oct</span>
          <input type="text" className="form-control" value={october} onChange={this.changeOctober} 
          
          style={{ fontSize: "12px" }}
          />
        </div>
        
        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>Nov</span>
          <input type="text" className="form-control" value={november} onChange={this.changeNovember} 
          
          style={{ fontSize: "12px" }}
          />
        </div>

        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>Dec</span>
          <input type="text" className="form-control" value={december} onChange={this.changeDecember} 
          
          style={{ fontSize: "12px" }}
          />
        </div>

        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>Jan</span>
          <input type="text" className="form-control" value={january} onChange={this.changeJanuary} 
          
          style={{ fontSize: "12px" }}
          />

        </div>

        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>Feb</span>
          <input type="text" className="form-control" value={february} onChange={this.changeFebruary} 
          
          style={{ fontSize: "12px" }}
          />
        </div>
        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>Mar</span>
          <input type="text" className="form-control" value={march} onChange={this.changeMarch} 
          
          style={{ fontSize: "12px" }}
          />
        </div>

        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>Apr</span>
          <input type="text" className="form-control" value={april} onChange={this.changeApril} 
          
          style={{ fontSize: "12px" }}
          />
        </div>
        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>May</span>
          <input type="text" className="form-control" value={may} onChange={this.changeMay} 
          
          style={{ fontSize: "12px" }}
          />

        </div>

        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>Jun</span>
          <input type="text" className="form-control" value={june} onChange={this.changeJune} 
          
          style={{ fontSize: "12px" }}
          />

        </div>

        {bpyid === 0 ? (
          <button type="button" className="btn btn-primary float-start" style={{ fontSize: "12px" }} onClick={() => this.copyClick()}>
            Create
          </button>
        ) : null}

        {bpyid !== 0 ? (
          <button type="button" className="btn btn-primary float-start" style={{ fontSize: "12px" }} onClick={() => this.createClick()}>
            Create
          </button>
        ) : null}
      </div>
    </div>
  </div>
</div>

<div className="modal fade" id="exampleModal2" tabIndex="-1" aria-hidden="true">
  <div className="modal-dialog modal-lg modal-dialog-centered">
    <div className="modal-content">
      <div className="modal-header">
        <h5 className="modal-title" style={{ fontSize: "12px" }} >{modalTitle}</h5>
        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div className="modal-body">

      <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }} >Fiscal Year</span>
          <select
            className="form-select"
            value={this.state.fyname}
            onChange={(event) => this.setState({ fyname: event.target.value })}
            disabled={this.state.isEditClicked}
            style={{ fontSize: "12px" }} 
          >
            <option value="">Select fiscal year</option>
            {this.state.fiscalYears.map((fiscalyear) => (
              <option key={fiscalyear} value={fiscalyear}>
                {fiscalyear}
              </option>
            ))}
          </select>
        </div>
        




        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }} >Jul</span>
          <input type="number" className="form-control" value={july} onChange={this.changeJuly} 
          
          style={{ fontSize: "12px" }} 
          />
        </div>

        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }} >Aug</span>
          <input type="text" className="form-control" value={august} onChange={this.changeAugust}
          
          style={{ fontSize: "12px" }} 
           />
        </div>

        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>Sep</span>
          <input type="text" className="form-control" value={september} onChange={this.changeSeptember} 
          
          style={{ fontSize: "12px" }}
          />
        </div>

        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>Oct</span>
          <input type="text" className="form-control" value={october} onChange={this.changeOctober} 
          
          style={{ fontSize: "12px" }}
          />
        </div>
        
        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>Nov</span>
          <input type="text" className="form-control" value={november} onChange={this.changeNovember} 
          
          style={{ fontSize: "12px" }}
          />
        </div>

        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>Dec</span>
          <input type="text" className="form-control" value={december} onChange={this.changeDecember} 
          
          style={{ fontSize: "12px" }}
          />
        </div>

        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>Jan</span>
          <input type="text" className="form-control" value={january} onChange={this.changeJanuary} 
          
          style={{ fontSize: "12px" }}
          />

        </div>

        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>Feb</span>
          <input type="text" className="form-control" value={february} onChange={this.changeFebruary} 
          
          style={{ fontSize: "12px" }}
          />
        </div>
        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>Mar</span>
          <input type="text" className="form-control" value={march} onChange={this.changeMarch} 
          
          style={{ fontSize: "12px" }}
          />
        </div>

        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>Apr</span>
          <input type="text" className="form-control" value={april} onChange={this.changeApril} 
          
          style={{ fontSize: "12px" }}
          />
        </div>
        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>May</span>
          <input type="text" className="form-control" value={may} onChange={this.changeMay} 
          
          style={{ fontSize: "12px" }}
          />

        </div>

        <div className="input-group mb-3">
          <span className="input-group-text" style={{ fontSize: "12px" }}>Jun</span>
          <input type="text" className="form-control" value={june} onChange={this.changeJune} 
          
          style={{ fontSize: "12px" }}
          />

        </div>

        {bpyid === 0 ? (
          <button type="button" className="btn btn-primary float-start" style={{ fontSize: "12px" }} onClick={() => this.createClick()}>
            Create
          </button>
        ) : null}

        {bpyid !== 0 ? (
          <button type="button" className="btn btn-primary float-start" style={{ fontSize: "12px" }} onClick={() => this.updateClick(bpyid)}>
            Update
          </button>
        ) : null}
      </div>
    </div>
  </div>
</div>


</div>
  )
}
  }




